<template>
  <div class="social-share">
    <social-icons-loader v-if="!linkMade" />
    <div
      v-if="linkMade"
      class="social-icons"
    >
      <!-- <img :src="facebookIcon" >
      <img :src="twitterIcon" >
      <img :src="emailIcon" >
      <img :src="linkIcon" > -->
      <a
        :href="facebookLink"
        rel="noopener noreferrer"
        target="_blank"
        data-test="link-facebook"
      >
        <img src="../assets/images/share_facebook.svg" >
      </a>
      <a
        :href="twitterLink"
        rel="noopener noreferrer"
        target="_blank"
        data-test="link-twitter"
      >
        <img src="../assets/images/share_twitter.svg" >
      </a>
      <a
        :href="mailLink"
        rel="noopener noreferrer"
        data-test="link-mail"
      >
        <img src="../assets/images/share_email.svg" >
      </a>
      <!-- <a
        v-clipboard:copy="link"
        v-clipboard:success="onCopy"
      >
        <img :src="linkIcon" >
      </a> -->
    </div>
  </div>
</template>
<script>
import * as log from 'loglevel';
import Branch from '../services/Branch';
import SocialIconsLoader from './loaders/SocialIconsLoader';

export default {
  components: { SocialIconsLoader },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    showData: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      link: '',
      // mailLink: '',
      smsLink: '',
      linkMade: false,
      branch_service: new Branch(),
    };
  },
  computed: {
    facebookLink() {
      const lnk = `https://www.facebook.com/sharer/sharer.php?u=${this.link}`;
      return lnk;
    },
    twitterLink() {
      const lnk = `https://twitter.com/intent/tweet?url=${this.link}`;
      return lnk;
    },
    mailLink() {
      return `mailto:?Subject=${this.showData.title}&Body=${this.link}`;
    },
  },
  beforeMount() {
    this.createSharingLink();
  },
  methods: {
    createSharingLink() {
      const data = this.formatBranchMetaData();
      this.branch_service.createLink(this.type, data).then((resp) => {
        this.link = resp;
        this.smsLink = `sms:?body=${this.link}`;
        this.linkMade = true;
      }).catch((error) => { log.info(error.message); });
      // this.mailLink = `mailto:?Subject=${this.showData.title}&Body=${this.link}`;
    },
    close() {
      this.$emit('close');
    },
    onCopy() {
      log.info('Copy');
      this.showSuccessMsg('Copied to clipboard');
    },
    mail() {
      log.info('Mail');
    },
    formatBranchMetaData() {
      let data = {};
      if (this.type === 'podcast') {
        data = this.formatPodcastData();
      } else if (this.type === 'episode') {
        data = this.formatEpisodeData();
      }
      let shareImage = '';
      if (this.showData && this.showData.image_url && this.showData.image_url !== '') {
        shareImage = this.showData.image_url;
      } else if (this.showData && (!this.showData.image_url || this.showData.image_url === '')
        && this.showData.season && this.showData.season.podcast
        && this.showData.season.podcast.image_url) {
        shareImage = this.showData.season.podcast.image_url;
      }
      data.$og_title = this.showData.title;
      data.$og_description = this.showData.description;
      data.$og_image_url = shareImage;
      data.$og_image_width = '1024';
      data.$og_image_height = '512';
      return data;
    },
    formatPodcastData() {
      const data = {
        publisher_slug: this.showData && this.showData.publisher && this.showData.publisher.slug,
        show_slug: this.showData.slug,
        podcast_uuid: this.showData.uuid,
        $desktop_url: `${window.location.origin}${window.location.pathname}`,
      };
      return data;
    },
    formatEpisodeData() {
      const data = {
        publisher_slug: this.showData && this.showData.season && this.showData.season.podcast && this.showData.season.podcast.publisher && this.showData.season.podcast.publisher.slug ? this.showData.season.podcast.publisher.slug : '',
        show_slug: this.showData && this.showData.season && this.showData.season.podcast && this.showData.season.podcast.slug ? this.showData.season.podcast.slug : '',
        episode_slug: this.showData.slug,
        episode_uuid: this.showData.uuid,
        $desktop_url: `${window.location.origin}${window.location.pathname}`,
      };
      return data;
    },
  },
};
</script>
<style lang="scss">
.social-share{
  .social-icons {
    a {
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 24px;
      }
    }
  }

  span{
    color: #606266;
    border: 1px solid #606266;
    border-radius: 50%;
    padding: 8.5px 19px;
    position: relative;
    margin-right: 16px;
    cursor: pointer;
    a{
      color: #606266;
    }
    i{
      font-size: 22px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/SocialShare.vue